import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TopBar from '../components/TopBar';
import { api } from '../api/client';

type AvisoDetalle = {
  id: number;
  titulo: string;
  tipo: string | null;
  contenido: string | null;
  imagen_url: string | null;
  publicado_en: string;
  vence_en: string | null;
  area: string | null;
  publicado_por: string | null;
  imagenes: { id: number; ruta: string }[];
};

function fmtFecha(s: string) {
  return new Date(s.replace(' ', 'T')).toLocaleDateString('es-AR', {
    day: '2-digit', month: 'long', year: 'numeric',
  });
}

const TIPO_COLOR: Record<string, string> = {
  alerta:     '#dc2626',
  comunicado: '#2563eb',
  noticia:    '#10b981',
  aviso:      '#d97706',
};

export default function DetalleAviso() {
  const { id } = useParams();
  const [aviso, setAviso] = useState<AvisoDetalle | null>(null);
  const [err, setErr]     = useState<string | null>(null);

  useEffect(() => {
    api<AvisoDetalle>(`/avisos?id=${id}`)
      .then(setAviso)
      .catch((e) => setErr(e.message));
  }, [id]);

  return (
    <>
      <TopBar title="Aviso" back />
      <main className="max-w-md mx-auto px-4 py-4 pb-24">
        {err && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl p-3">{err}</div>
        )}
        {!aviso && !err && <p className="text-center text-gray-400 pt-10">Cargando…</p>}
        {aviso && (
          <article className="space-y-4">
            {aviso.imagen_url && (
              <img
                src={aviso.imagen_url}
                alt=""
                className="w-full rounded-xl object-cover"
                style={{ maxHeight: 220 }}
              />
            )}
            <div>
              {aviso.tipo && (() => {
                const color = TIPO_COLOR[aviso.tipo] ?? '#6b7280';
                return (
                  <span
                    className="text-xs font-bold px-2.5 py-0.5 rounded-full"
                    style={{ backgroundColor: color + '20', color }}
                  >
                    {aviso.tipo.charAt(0).toUpperCase() + aviso.tipo.slice(1)}
                  </span>
                );
              })()}
              <h1 className="text-xl font-extrabold text-gray-900 mt-2 leading-snug">{aviso.titulo}</h1>
              <p className="text-xs text-gray-400 mt-1">
                {aviso.area ? `${aviso.area} · ` : ''}
                {fmtFecha(aviso.publicado_en)}
                {aviso.publicado_por ? ` · ${aviso.publicado_por}` : ''}
              </p>
            </div>

            {aviso.contenido ? (
              <div className="bg-white border border-app rounded-xl p-4">
                <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">
                  {aviso.contenido}
                </p>
              </div>
            ) : null}

            {aviso.imagenes.length > 0 && (
              <div>
                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-2">Imágenes</p>
                <div className="grid grid-cols-2 gap-2">
                  {aviso.imagenes.map((img) => (
                    <img
                      key={img.id}
                      src={`/ciudadapp/uploads/avisos/${img.ruta}`}
                      alt=""
                      className="w-full rounded-xl object-cover aspect-video"
                    />
                  ))}
                </div>
              </div>
            )}
          </article>
        )}
      </main>
    </>
  );
}
